import { AgeGroup, getAgeGroup } from '@repo/utils';
import { Typography } from 'components';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import type { MainFinding } from 'views/Results/Summary/SummaryCards/NoteCard/useMainFindings';
import MicrobiomeHealthScoresCards from '../components/MicrobiomeHealthScoresCards';
import { SLIDE_BACKGROUND_COLORS } from '../slideBackgroundColors';
import styles from './MicrobiomeHealthScores.module.css';
import slideStyles from './Slides.module.css';

interface MicrobiomeHealthScoresProps {
  mainFindings: MainFinding[];
}

export default function MicrobiomeHealthScores({
  mainFindings,
}: MicrobiomeHealthScoresProps) {
  const { currentKit, currentTinyAccount } = useCurrentKitAndTinyAccount();
  const isAdult =
    getAgeGroup(currentKit?.age_at_sampling ?? 0) === AgeGroup.ADULT;

  return (
    <div
      className={slideStyles.slideWrapper}
      style={{
        backgroundColor: SLIDE_BACKGROUND_COLORS.microbiomeHealthScores,
      }}
    >
      <div className={styles.contentContainer}>
        <Typography
          variant='heading-2xl'
          color='darkPurple'
          weight='medium'
          className={styles.title}
        >
          {isAdult ? 'Your' : `${currentTinyAccount?.first_name}'s`} microbiome
          health scores
        </Typography>
        <MicrobiomeHealthScoresCards mainFindings={mainFindings} />
      </div>
    </div>
  );
}
